var is_active_subscriber = false;

function waitTillJQuery(){
  if(typeof($)=='function'){
    clearInterval(timer);

    applySlickSlider= function(containerSelector){
      $(containerSelector).slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToScroll: 1,
        arrows: true,
        centerMode: false,
        centerPadding: 0,
        slidesToShow: 4,
        nextArrow: '<div class="icon-holder right-arrow"><i class="swell-icon-chevron-thin-right slick-arrows"></i></div>',
        prevArrow: '<div class="icon-holder left-arrow"><i class="swell-icon-chevron-thin-left slick-arrows"></i></div>',
        responsive: [
        {
          breakpoint: 768,
          settings: {
            infinite:true,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '31vw 10vw',
            slidesToScroll: 1,

          }
        },
        ]
      });
    }
    timer = false;
    (function () {
      $(document).ready(function () {
        if(localStorage.getItem("swell-page-refresh")=="true"){
          $('.js-cart-icon-count a').click();
          localStorage.removeItem("swell-page-refresh");
        }
        $("body").on("click", ".redemption-for-product-relode-click", function() {
          $(document).on("swell:cart:updated", function() {
            localStorage.setItem("swell-page-refresh", "true");
            location.reload();
          });
        });
        $('body').on('click', '.faq-question', function () {
          if ($(this).find('.answer').height()==0) {
            $(this).find('.answer').css('height','auto');
            $(this).find('.question').addClass("open");
            $(this).siblings().find('.answer').height(0);
            $(this).siblings().find('.question').removeClass("open");
          }
          else {
            $(this).find('.answer').height(0);
            $(this).find('.question').removeClass("open");
          }
        });
        $(document).on("swell:setup", function () {
					let $referral_widget = $('.yotpo-widget-referral-widget');
          $referral_widget.addClass('swell-rewards-refer-tile');
					$referral_widget.find('.yotpo-email-view').append('<a class="yotpo-financial-incentive-link" target="_blank" href="/pages/terms-conditions-and-privacy-policies#financial-incentive">Notice of Financial Incentive</a>')
          $('body').on("click",".refer-tile",function(){
            $('html,body').animate({
              scrollTop: $(".swell-rewards-refer-tile").offset().top - 80},
              'slow');
          });
          // const targetNode = document.getElementById('swell-cart-item-holder');
          // const config = { attributes: true, childList: true, subtree: true };
          // const callback = function(mutationsList, observer) {
          //   Swell.Cart.getCart();
          // };
          // const observer = new MutationObserver(callback);
          // observer.observe(targetNode, config);
          Swell.Campaign.initializeCampaigns(".campaign-holder", SwellConfig.Campaign.opts);
          SwellConfig.Campaign.referTile();
          SwellConfig.Campaign.campaignHover();
          SwellConfig.Campaign.campaignComplete();
          Swell.Redemption.initializeProductRedemptions(".redeem-for-products-content-holder", SwellConfig.ProductRedemption.opts);
          Swell.Redemption.redemptionHover();
          applySlickSlider(".redeem-for-products-content-holder");
          if($(".tier-holder").length>0){
            SwellConfig.Tier.initializeCustomTierProperties();
            SwellConfig.Tier.initializeTiers(".tier-holder");
            SwellConfig.Tier.setupSlick(".tier-holder");
          }
          if (spapi.authenticated) {
              swellAPI.refreshEmbeds();
          }
          $(".swell-lds-holder").remove();
        });
        $(document).on("swell:customer:updated", function () {
          SwellConfig.Campaign.campaignComplete();
        });
      });
    }).call(this);
    return;
  }
}
var timer = setInterval(waitTillJQuery, 15);

// function swellCheckitems(){
//   var cart = $.ajax({
//       type: 'GET',
//       url: '/cart.js',
//       dataType: 'json',
//       success: function(){
//         if(cart.responseJSON.item_count>0){
//           var isPricedItem = 0;
//           cart.responseJSON.items.forEach(function(item)
//           {
//             if(item.final_price > 0)
//             {
//               if(item.properties["_swell_discount_type"] === undefined)
//               {
//                 isPricedItem = 1;
//                 return false;
//               }
//             }
//           });
//           if(isPricedItem == 0)
//           {
//             window.location.href = "/cart/clear";
//           }
//         }
//       }
//     });
// }

//campains
(function () {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign:"<li class='swell-campaign'> <div class=' campaign-list' > <div class='swell-campaign-content swell-campaign-container' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='<%= campaign.icon %>'> </i> </span> </div> <div class='swell-campaign-header'> <span class='swell-header-details'><%= campaign.reward_text %></span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-details'><%= campaign.title %></span> </div> </div> </div> </li>",
        campaignHover: '<div class="swell-campaign-hover"> <div class="swell-campaign-hover-content"> <ul class="swell-link-list"> <li class="swell-link"><a href="/account/login?checkout_url=/pages/rewards" class="swell-link-login btn">Sign In</a></li> <li class="swell-link"><a href="/account/login?checkout_url=/pages/rewards" class="swell-link-register btn">Sign Up</a></li> </ul> </div> </div>'
      }
    },
    campaignHover: function() {
      if (!spapi.authenticated) {
        return $(".swell-campaign-content").hover(function() {
          return $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
        }, function() {
          return $(this).find(".swell-campaign-hover").remove();
        });
      }
    },
    campaignComplete: function(){
      if(spapi.authenticated) {
        var campaigns=spapi.activeCampaigns;
        campaigns.forEach(function(campaign){
          if(campaign.customerCompleted) {
            $(".campaign-holder .swell-campaign .swell-campaign-content[data-campaign-id='"+campaign.id+"']").css("opacity","0.4");
          }else if(campaign.type=='BirthdayCampaign' && spapi.customer.birthday != undefined){
            $(".campaign-holder .swell-campaign .swell-campaign-content[data-campaign-id='"+campaign.id+"']").css("opacity","0.4");
          }
        });
      }
    },
    referTile:function(){
        $("li div[data-campaign-id='558932'").parent().parent().remove();
      $(".campaign-holder").append("<li class='swell-campaign'> <div class=' campaign-list' > <div class=' swell-campaign-container refer-tile'><img class = 'swell-refer-tile-img' src='//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-refer.svg?v=134375667663305710051718034967'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> </span> </div> <div class='swell-campaign-header swell-custom-header-details'> <span class='swell-header-details '>850 Points </span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-details'>Refer a Friend</span> </div> </div> </div> </li>")
    }
	};
}).call(this);
// Product redemption

(function () {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.ProductRedemption = {
    opts: {
      templates: {
        redemptionOptionProduct: '<div class="redeem-for-products-content redemption-for-product-relode-click swell-buy-product-btn" data-variant-id="<%= redemption.applies_to_id %>" coupon_id="<%= redemption.id %>" data-confirm-btn-text="Redeem this Product"data-box-width="400px" data-mobile-box-width="90%"><div class="products-holder"><img class="redeem-for-products-content-image lazyload" data-src="<%= redemption.background_image_url %>"><div class="redeem-for-products-header"><%= redemption.name %></div><div class="redeem-points"><%= redemption.cost_text %></div></div></div>',
        redemptionHover: '<div class="swell-campaign-hover"> <redeem-for-products-contentdiv class="swell-campaign-hover-content"> <ul class="swell-link-list"> <li class="swell-link"><a href="/account/login?checkout_url=/pages/rewards" class="swell-link-login btn">Sign In</a></li> <li class="swell-link"><a href="/account/login?checkout_url=/pages/rewards" class="swell-link-register btn">Sign Up</a></li> </ul> </div> </div>'
      },
      redemptionHover: function() {
      if (!spapi.authenticated) {
        return $(".products-holder").hover(function() {
          return $(this).append(SwellConfig.ProductRedemption.opts.templates.redemptionHover);
        }, function() {
          return $(this).find(".swell-campaign-hover").remove();
        });
      }
    },
    }
  };
}).call(this);

// tiers
(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if(customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getCustomerTierId: function () {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function (e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function (rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function (e) {
        return e.rank === rank;
      })[0];
    },
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[0].namePoints = spapi.activeVipTiers[0].name,
      spapi.activeVipTiers[0].requirementPoints = "$"+(new Intl.NumberFormat().format((spapi.activeVipTiers[0].amount_spent_cents)/100)) + " - $"+(new Intl.NumberFormat().format(((spapi.activeVipTiers[1].amount_spent_cents)/100)-1))+"",
      spapi.activeVipTiers[0].benefit1 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[0].benefit2 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[0].benefit3 = '',
      spapi.activeVipTiers[0].benefit4 = '',
      spapi.activeVipTiers[0].benefit5 = '',
      spapi.activeVipTiers[0].benefit6 = '',
      spapi.activeVipTiers[0].benefit7 = '',
      spapi.activeVipTiers[0].benefit8 = '',
      spapi.activeVipTiers[0].benefit9 = '',

      spapi.activeVipTiers[1].namePoints = spapi.activeVipTiers[1].name,
      spapi.activeVipTiers[1].requirementPoints = "$"+(new Intl.NumberFormat().format(((spapi.activeVipTiers[1].amount_spent_cents)/100))) + " - $"+(new Intl.NumberFormat().format(((spapi.activeVipTiers[2].amount_spent_cents)/100)-1))+"",
      spapi.activeVipTiers[1].benefit1 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[1].benefit2 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[1].benefit3 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[1].benefit4 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[1].benefit5 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[1].benefit6 = '',
      spapi.activeVipTiers[1].benefit7 = '',
      spapi.activeVipTiers[1].benefit8 = '',
      spapi.activeVipTiers[1].benefit9 = '',

      spapi.activeVipTiers[2].namePoints = spapi.activeVipTiers[2].name,
      spapi.activeVipTiers[2].requirementPoints = ("$"+(new Intl.NumberFormat().format(spapi.activeVipTiers[2].amount_spent_cents/100))+"+"),
      spapi.activeVipTiers[2].benefit1 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[2].benefit2 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[2].benefit3 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[2].benefit4 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[2].benefit5 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[2].benefit6 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[2].benefit7 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[2].benefit8 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">',
      spapi.activeVipTiers[2].benefit9 = '<img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-tier-icon.svg?v=1122929356321701531718034565">'
    },
    initializeTiers: function(containerSelector) {
      if($(".swell-tier-table").length>0)
      {
        $(".swell-tier-table").prepend('<li class="titles-col"> <span class="points-item"></span> <span class="points-item"></span> <span class="name-item">BENEFITS</span> <span class="list-point">Redeem Points for Products</span> <span class="list-point">Birthday Points</span> <span class="list-point">Free Standard Shipping on Clean Boutique orders</span> <span class="list-point">Early Access to New<br class="swell-mobile"> Products & Programs</span> <span class="list-point">Free Sampling of New<br class="swell-mobile"> Products</span> <span class="list-point">Seasonal Gifts</span> <span class="list-point">Dedicated Wellness<br class="swell-mobile"> Concierge Available<br class="swell-mobile"> via Text</span> <span class="list-point">Free Admission to<br class="swell-mobile"> Sakara Events</span> </li>');
      }
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      var count = 1;
      tiers.forEach(function (tier) {
        $(containerSelector).append('<div class="tier-'+count+'-col tier-list-item " data-tier-id='+tier.id+'> <span class="points-item tier-status"></span> <span class="points-item">Spend: <br class="swell-mobile">'+ tier.requirementPoints+'</span> <span class="name-item">'+tier.namePoints+' </span> <span>'+tier.benefit1+'</span> <span>'+tier.benefit2+'</span> <span>'+tier.benefit3+'</span> <span>'+tier.benefit5+'</span> <span>'+tier.benefit6+'</span> <span>'+tier.benefit7+'</span> <span>'+tier.benefit8+'</span> <span>'+tier.benefit9+'</span> </div>');
        count++;
      });
      if(spapi.authenticated) {
        SwellConfig.Tier.setupCustomerTierStatus();
      }
    },
    setupCustomerTierStatus: function () {
      var toGoNext, next_tier;
      var last_tier = spapi.activeVipTiers.length;
      var last_tier_rank = SwellConfig.Tier.getTierByRank(last_tier - 1);

      if (spapi.customer.vip_tier) {
        var $customer_tier_id;// $customer_tier_rank;
        customer_tier_id = SwellConfig.Tier.getCustomerTierId();
        customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
        tiers = spapi.activeVipTiers;
        tiers.forEach(function (tier) {
          if (tier.id == customer_tier_id) {
            customer_tier = tier;
          }
        });
        if (last_tier_rank.rank == customer_tier_rank) {
          tiers.forEach(function (tier) {
            if (tier.rank == customer_tier.rank) {
              $("div[data-tier-id='" + tier.id + "'] .points-item.tier-status").append("<strong>Current Status</strong>");
              $("div[data-tier-id='" + tier.id + "']").addClass("customer-tier-status"+tier.rank);
            }
          });
        } else {
          next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
          toGoNext = (next_tier.amount_spent_cents - spapi.customer.vip_tier_stats.amount_spent_cents) / 100;
          if(toGoNext < 0)
          {
            toGoNext = 0;
          }
          tiers.forEach(function (tier) {
            if (tier.rank == customer_tier.rank) {
              $(`div[data-tier-id='${tier.id}']`).addClass('is-current-tier');
              $("div[data-tier-id='" + tier.id + "'] .points-item.tier-status").append("<strong>Current Status</strong>");
              $("div[data-tier-id='" + next_tier.id + "'] .points-item.tier-status").append(" Spend $" + toGoNext + " more to earn "+next_tier.name+"");
              $("div[data-tier-id='" + tier.id + "']").addClass("customer-tier-status"+tier.rank);
            }
          });
        }
      }
      else {
        next_tier = SwellConfig.Tier.getTierByRank(0);
        toGoNext = (next_tier.amount_spent_cents - spapi.customer.vip_tier_stats.amount_spent_cents) / 100;
        if(toGoNext < 0) {
          toGoNext = 0;
        }
       $("div[data-tier-id='" + next_tier.id + "'] .points-item.tier-status").append(" Spend $" + toGoNext + " more to earn "+next_tier.name+"");
      }
    },
    setupSlick: function(containerSelector){
      $(containerSelector).slick({

        infinite: true,
        speed: 300,
        slidesToScroll:1,
        slidesToShow: 3,
        dots: false,
        responsive: [
        {
          breakpoint: 768,
          settings: {
            prevArrow: '<button type="button" class="swell-slick-button slick-prev"><img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-left-arrow.svg?v=14553395638580840181718034991" /></button>',
            nextArrow: '<button type="button" class="swell-slick-button slick-next"><img src="//sakara-dev.myshopify.com/cdn/shop/t/950/assets/swell-right-arrow.svg?v=14553395638580840181718035644" /></button>',
            dots:false,
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
        ]
      });
      }
  }
}).call(this);

// This fires when we click on "Redeem Now" button
window.onBeforeProductRedemption = function(opts, redemptionOption, pointBalance, cb) {
  // If the requested redemption is the 1-day OMD option, don't use the usual flow of product redemption,
  // instead, if the current user is an active subscriber, show a popup with a form to submit to Zendesk, or,
  // if the current user is not an active subscriber, redirect to the Signature landing.
  if (redemptionOption.id === 345064) {
    const has_elapsed_time_since_meal_redemption = document.cookie.includes('elapsed_time_since_meal_redemption');
    if (has_elapsed_time_since_meal_redemption) {
      spapi.$.confirm({
        title: "Oops!",
        content: "You can only make one request per 24 hours for:<br> 1 Day of Organic Meal Delivery.",
        type: "red",
        typeAnimated: true,
        useBootstrap: false,
        boxWidth: "400px",
        buttons: {
          ok: {
            text: "Ok",
            action: function () {
            }
          }
        }
      });
    } else if (redemptionOption.amount > pointBalance) {
      spapi.$.confirm({
        title: "Oops!",
        content: "Looks like you don't have enough points for this product. This product costs " + redemptionOption.amount  + " points and you only have " + pointBalance + " points available.",
        type: "red",
        typeAnimated: true,
        useBootstrap: false,
        boxWidth: "400px",
        buttons: {
          ok: {
            text: "Ok",
            action: function () {
            }
          }
        }
      });
    } else {
      $(document).trigger('request-subscription-reward');
      let next_available_redemption_time = moment().add('1', 'd').toDate();
      document.cookie = `elapsed_time_since_meal_redemption=24;expires=${next_available_redemption_time};`;
    }
  } else {
    var redeemedItemsInCart = 0;
    var pricedItemsInCart = 0;
    var discountInCart = 0;

    if(Swell.Cart && Swell.Cart.items) {
      var cart = Swell.Cart;

      $.each(cart.items, function(index, item){
        if(item.line_price > 0){
          pricedItemsInCart++;
        }
      });

      if (theme.cart.has_omd_subscription || theme.cart.has_cb_subscription) {
        spapi.$.confirm({
          title: "Oops!",
          content: "It looks like you have a subscription in your cart, which cannot be processed with reward redemptions. Please complete your subscription purchase and place a separate order to redeem your reward (with any Sakara Shop product or one-time meal delivery program). Please refer to our FAQs or contact us at info@sakaralife.com with questions.",
          type: "red",
          typeAnimated: true,
          useBootstrap: false,
          boxWidth: "400px",
          buttons: {
            ok: {
              text: "Ok",
              action: function () {
              }
            }
          }
        });
      } else if (pricedItemsInCart == 0){
        spapi.$.confirm({
          title: "Oops!",
          content: "In order to redeem this reward, please add a Clean Boutique product or one-time meal delivery program to your cart. Rewards can only be selected in conjunction with Sakara purchases. Please refer to our FAQs or contact us at info@sakaralife.com with questions.",
          type: "red",
          typeAnimated: true,
          useBootstrap: false,
          boxWidth: "400px",
          buttons: {
            ok: {
              text: "Ok",
              action: function () {
              }
            }
          }
        });
      } else if (redemptionOption.amount > pointBalance) {
        spapi.$.confirm({
          title: "Oops!",
          content: "Looks like you don't have enough points for this product. This product costs " + redemptionOption.amount  + " points and you only have " + pointBalance + " points available.",
          type: "red",
          typeAnimated: true,
          useBootstrap: false,
          boxWidth: "400px",
          buttons: {
            ok: {
              text: "Ok",
              action: function () {
              }
            }
          }
        });
      } else {
        cb();
      }
    }
  }
};
